module.exports = __webpack_public_path__ + "img/movie6.e916a881.png";